// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1N1a8","search":"Settings_search__1pkU-","filter":"Settings_filter__3hF67"};